import { MAX_IMAGE_MB } from '../constants';

export const processImage = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let { width, height } = img;
        
        // Basic scaling if too large (Max 2000px width/height for sanity)
        const maxDim = 2000;
        if (width > maxDim || height > maxDim) {
          const ratio = Math.min(maxDim / width, maxDim / height);
          width *= ratio;
          height *= ratio;
        }

        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);

        // Compress to target MB
        let quality = 0.9;
        let dataUrl = canvas.toDataURL('image/jpeg', quality);
        
        while (dataUrl.length > MAX_IMAGE_MB * 1024 * 1024 && quality > 0.1) {
          quality -= 0.1;
          dataUrl = canvas.toDataURL('image/jpeg', quality);
        }

        resolve({
          id: `img-${Date.now()}`,
          type: 'image',
          dataRef: dataUrl,
          caption: '',
          width,
          height,
          rotation: 0,
          addedAt: Date.now()
        });
      };
      img.src = e.target.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};